import { faSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Row, Col } from 'react-bootstrap';

export const ProfileCastoInvest: React.FC = () => {
  return (
    <>
      <p>
        Are you wondering whether you should pull for Castorice Eidolons or her
        Light Cone? Or maybe there's another option? Then this section is for
        you!
      </p>
      <blockquote className="firefly-order">
        <p>
          <strong className={`Quantum`}>Castorice E0</strong> &gt;{' '}
          <strong className={`Quantum`}>Tribbie E0</strong> &gt;{' '}
          <strong className={`Quantum`}>Castorice S1</strong> &gt;{' '}
          <strong className={`Quantum`}>Castorice E2</strong>
        </p>
      </blockquote>
      <ol>
        <li>
          <strong>Tribbie E0</strong> - yes. That's right. Tribbie elevates
          Castorice performance to a new level (especially in PF) as she
          provides everything she needs. A lot HP to consume? Check. Non-diluted
          buffs? Check. FUA to trigger additional healing? Check. Decent own
          damage to help kill stragglers so the dragon can go fusrodah on a
          fresh wave? Check. Tribbie is also the most universal
          Sub-DPS/Amplifier that can be used with virtually anyone.
        </li>
        <li>
          <strong>Castorice S1</strong> - Due to the Remembrance path limited
          Light Cone options, her signature is a large improvement over her
          other options. Notably the Action Advance from this Light Cone can
          allow you to hit AV breakpoints such as the first cycle in Memory of
          Chaos - since her in-combat SPD with 4-Pc Poet’s upper limit is ~133.
          This Light Cone also significantly increases her Max HP, allowing for
          more HP to be consumed for her Ultimate Charges and has a whopping 30%
          DEF SHRED - a stat she doesn't have easy access to elsewhere and which
          stacks incredibly well with other DEF shredding sources.
        </li>
        <li>
          <strong>Castorice E2</strong> can be immensely powerful, granting
          Castorice 30% faster access to Netherwing, 2 extra breaths (leading to
          more damage and more DMG% buff stacks), and action advancement that
          allows her to use her Joint attacks incredibly frequently. All of this
          adds up to an absurdly powerful boost, but this boost comes with a
          catch. Keep in mind that the advancement from this Eidolon can
          severely interfere with certain support characters buff uptimes on
          Castorice, resulting in much lower gains in reality than in theory -
          this can be played around but is worth keeping in mind when assessing
          the power of this Eidolon.
        </li>
        <ul>
          <li>
            Yes, we have skipped E1. That's on purpose, because it's honestly
            not worth going for E1 if you're planning to stop there and don't
            pull E2.
          </li>
        </ul>
      </ol>
      <div className={`content-header Quantum`}>
        <FontAwesomeIcon icon={faSquare} width="18" /> Playstyles
      </div>
      <p>
        Currently, there are 2 main ways you can pilot Netherwing, either
        instantly detonating it, or to keep it up as long as possible. Keep in
        mind that autoplay will always immediately detonate Netherwing - which
        is actually the preferred playstyle for most teams (not always for
        Sunday) even on manual.
      </p>
      <h6>Instant Detonation Playstyle</h6>
      <p>
        The first way to play Castorice is to immediately spam the breath attack
        right after Netherwing is summoned, consuming all of Netherwing’s HP to
        trigger the Bounce attack. The reason to do this is that her finisher
        attack is extremely potent and triggering it as many times as possible
        is key to maximising damage (especially in single target).
      </p>
      <p>
        The other reason behind instant detonation is to take full advantage of
        her A6 in order to ensure the explosion has as many stacks of her 30%
        buff as possible! Also with the Remembrance Trailblazer in the team, as
        long as Castorice has Mem’s Support, Netherwing will inherit the buff
        when it is summoned with no buff uptime issues. With Sunday however, it
        is recommended to wait until Netherwing is buffed before consuming all
        HP.
      </p>
      <div className="section-analysis">
        <Row className="pros-cons">
          <Col sm="12" md="6">
            <div className="box pros">
              <h5>Pros</h5>
              <hr />
              <div className="raw list">
                <ul>
                  <li>Most suitable for Hypercarry Castorice,</li>
                  <li>
                    No healing/HP loss wasted - all gets converted into Ultimate
                    Charge,
                  </li>
                  <li>
                    Strong Single-Target DMG from Memosprite Talent, and ensures
                    maximum DMG Boost stacks while triggering it,
                  </li>
                  <li>
                    Triggers the summon/exit more often for the Action Advance
                    from signature Light Cone or E2.
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col sm="12" md="6">
            <div className="box cons">
              <h5>Cons</h5>
              <hr />
              <div className="raw list">
                <ul>
                  <li>
                    Significant pressure on healing/HP loss - Netherwing can be
                    inactive for a long time if there is not enough healing to
                    resummon it back up,
                  </li>
                  <li>
                    Team won't have access to Netherwing’s 20% RES PEN territory
                    effect consistently.
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <h6>Maintaining Netherwing Playstyle</h6>
      <p>
        To keep Netherwing on the field, you can avoid using the Breath attack
        when it's at 25% HP or lower by using the Claw attack - generally you
        can do 3 Breath + Claw when Netherwing is at 100% HP.
      </p>
      <div className="section-analysis">
        <Row className="pros-cons">
          <Col sm="12" md="6">
            <div className="box pros">
              <h5>Pros</h5>
              <hr />
              <div className="raw list">
                <ul>
                  <li>
                    20% All-Type RES reduction debuff, so allies benefit from
                    it,
                  </li>
                  <li>
                    Lower pressure on Ultimate Charge, since Netherwing will
                    stay around for 3 turns.
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col sm="12" md="6">
            <div className="box cons">
              <h5>Cons</h5>
              <hr />
              <div className="raw list">
                <ul>
                  <li>
                    While not strictly required, you still need potent healing
                    to ensure Netherwing can perform 3 Breath attacks every
                    turn.
                  </li>
                  <li>
                    Her powerful finisher attack does not trigger as often,
                    resulting in weak single-target performance.
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
